import Actions from "views/Actions/Actions.jsx";
import JobApplication from "views/JobApplication/JobApplication.jsx";
import Brokers from "views/Brokering/Brokers.jsx";
import Orders from "views/Brokering/Orders.jsx";
import UserProfile from "views/Profile/userProfile.jsx";
import ShipperProfile from "views/Profile/shipperProfile.jsx";
import VendorProfile from "views/Profile/vendorProfile.jsx";
import OrderProfile from "views/Profile/orderProfile.jsx";
import QuoteProfile from "views/Profile/quoteProfile.jsx";
import Profile from "views/Profile/Profile.jsx";
import PendingActions from "views/Admin/PendingActions.jsx";
import Users from "views/Admin/Users.jsx";
import Vendors from "views/Admin/Vendors.jsx";
import pagesRoutes from "./pages.jsx";


// @material-ui/icons
import Settings from "../views/Settings/Settings.jsx";
import DashboardIcon from "@material-ui/icons/Dashboard";
import Apps from "@material-ui/icons/Apps";
import Contacts from "@material-ui/icons/Contacts"
// import ContentPaste from "@material-ui/icons/ContentPaste";

// import SettingsApplications from '@material-ui/icons/SettingsApplications';
import Place from "@material-ui/icons/Place";
import Timeline from "@material-ui/icons/Timeline";
import Ship from "../views/Ship/Ship.jsx";
import PlaceOrder from "../views/Customer/PlaceOrder.jsx";
import NotificationsParent from "../views/Customer/NotificationsParent";
import CurrentOrders1 from "../views/Customer/CurrentOrders1.jsx";
import Lanes from "../views/Lanes/Lanes.jsx";
import Rates from "../views/Rates/Rates.jsx";
import FeedForms from "../components/Forms/FeedForms.jsx"
import Dispatch from "../views/Dispatch/Dispatch.jsx";
import Quote from "../views/Dispatch/Quote.jsx";
import Carriers from "../views/Admin/Carriers.jsx";
import DispatchedOrders from "../views/Dispatch/DispatchedOrders.jsx";
import DispatchedOrdersDriver from "../views/Driver/DispatchedOrders.jsx";
import ConfirmedOrders from "../views/Dispatch/ConfirmedOrders.jsx";
import DispatchedOrders1 from "../views/Driver/DispatchedOrders1.jsx";
import SettingsApplications from '@material-ui/icons/SettingsApplications';
import ContactSupport from '@material-ui/icons/ContactSupport';
import LocalShipping from '@material-ui/icons/LocalShipping';
import PersonIcon from '@material-ui/icons/Person';
import LocalAtm from '@material-ui/icons/LocalAtm';
import History from '@material-ui/icons/History';
import NotificationImportant from '@material-ui/icons/NotificationImportant';
import Receipt from '@material-ui/icons/Receipt';
import AttachMoney from '@material-ui/icons/AttachMoney';
import BusinessIcon from '@material-ui/icons/Business';
import Shippers from "../views/Admin/Shippers.jsx";
import companyProfile from "../views/Profile/companyProfile.jsx";
import CompletedOrders from "../views/Dispatch/CompletedOrders.jsx";
import Flights from "../views/Flights/Flights.jsx";
import OrdersDetails from "../views/Orders/OrdersDetails.jsx";
import DispatchedOrdersParent from "../views/Dispatch/DispatchedOrdersParent.jsx";


export default [ 
  // {
  //   collapse: true,
  //   admin: true,
  //   path: "/admin",
  //   name: "Admin",
  //   icon: DashboardIcon,
  //   views: [
  //     { path: "/admin/users", name: "Users", icon: ContactSupport, component: Users },   
  //   ]
  // }, 
  // { path: "/dashboard", name: "DASHBOARD", icon: DashboardIcon, component: Actions },
 
  { path: "/profile", name: "PROFILE", icon: PersonIcon, component: Profile }, 
  // { path: "/company", name: "COMPANY", icon: BusinessIcon, component: companyProfile }, 
  // { path: "/users", admin: true, name: "USERS", icon: PersonIcon, component: Users },   
  { path: "/user/:id", admin: true, name: "USER PROFILE", icon: PersonIcon, component: UserProfile },   
  // { path: "/shippers", name: "SHIPPERS", icon: Contacts, component: Shippers },   
  { path: "/shipper/:id", admin: true, name: "SHIPPER PROFILE", icon: PersonIcon, component: ShipperProfile },   
  { path: "/quote/:id", admin: true, name: "SHIPPER PROFILE", icon: PersonIcon, component: FeedForms },   
  { path: "/order/:id", admin: true, name: "SHIPPER PROFILE", icon: PersonIcon, component: OrdersDetails },   
  // { path: "/vendors/", name: "VENDORS", icon: Contacts, component: Vendors },   
  { path: "/vendor/:id", admin: true, name: "VENDOR PROFILE", icon: PersonIcon, component: VendorProfile },   
  { path: "/flight/:id", admin: true, name: "FLIGHTS", icon: PersonIcon, component: Flights },   
  // { path: "/quotes",  name: "QUOTES", icon: LocalAtm, component: CurrentOrders1 },   
  // {
  //   collapse: true,
  //   path: "/entities",
  //   name: "ENTITIES",
  //   icon: Contacts,
  //   state: "openEntities",
  //   views: [
  //     { path: "/entities/shippers", name: "SHIPPERS", component: Shippers },   
  //     { path: "/entities/vendors", name: "VENDORS", component: Vendors },  
  //   ]
  // }, 

  // { path: "/ship", name: "SHIP", icon: LocalShipping, component: FeedForms },    
  //{ path: "/feed", customer: true, name: "Form", component: FeedForms }, 
  // { path: "/history",  name: "HISTORY", icon: History, component: CurrentOrders1 },
  // { path: "/billing", name: "BILLING", icon: AttachMoney, component: CurrentOrders1 },
  // { path: "/lanes", user: true, name: "Lane Benchmarks", icon: ContactSupport, component: Lanes },
  
  // {
  //   collapse: true,
  //   path: "/orders",
  //   name: "ORDERS",
  //   icon: ContactSupport,
  //   state: "openOrders",
  //   views: [
  //     // { path: "/orders/pending-orders", name: "PENDING ORDERS", component: Quote },   
  //     // { path: "/orders/quoted-orders", name: "QUOTED ORDERS", component: Quote },  
  //     // { path: "/orders/booked-orders", name: "BOOKED ORDERS", component: Dispatch },  
  //     { path: "/orders/dispatched-orders", name: "DISPATCHED ORDERS", component: DispatchedOrders },  
  //     { path: "/orders/in-transit-orders", name: "IN TRANSIT ORDERS", component: DispatchedOrders },  
  //     { path: "/orders/delivered-orders", name: "DELIVERED ORDERS", component: CompletedOrders },  
  //   ]
  // }, 
    
  // { path: "/pending-orders", name: "PENDING ORDERS", icon: ContactSupport, component: Dispatch },   
  // { path: "/dispatched-orders", name: "DISPATCHED ORDERS", icon: ContactSupport, component: DispatchedOrders },
  // { path: "/completed-orders", name: "COMPLETED ORDERS", icon: ContactSupport, component: CompletedOrders },
  { path: "/orders",  name: "ORDERS", icon: NotificationImportant, component: DispatchedOrdersParent },
  { path: "/notifications",  name: "NOTIFCATIONS", icon: NotificationImportant, component: NotificationsParent },
  { path: "/support", name: "SUPPORT", icon: ContactSupport, component: Profile },
  { path: "/settings", name: "SETTINGS", icon: SettingsApplications, component: Settings },  

  // //{ path: "/routing", user: true, name: "Dispatch", component: Dispatch },    
  // { path: "/financials", user: true, name: "Financials", icon: ContactSupport, component: Profile },    
  // { path: "/hr", user: true, name: "HR", icon: ContactSupport, component: Profile },    
  // { path: "/driver", carrier: true, name: "Driver", icon: ContactSupport, component: DispatchedOrders1 },
  // { path: "/rates", carrier: true, name: "Rate Matrix", icon: ContactSupport, component: Rates },
  //{ path: "/carriers", name: "Carriers", component: Carriers },
  // {
  //   collapse: true,
  //   path: "/assess",
  //   name: "Assess",
  //   icon: DashboardIcon,
  //   state: "openAssess",
  //   views: [
  //     { path: "/assess/assessment", name: "Take the Assessment", component: Profile },   
  //     { path: "/assess/path", name: "Path to Purposeful Leadership", component: Profile },
  //     { path: "/assess/purpose", name: "Purpose Embraced Path", component: Profile },
  //     { path: "/assess/stakeholders", name: "Stakeholders Engaged Path", component: Profile },
  //     { path: "/assess/strategy", name: "Strategy Aligned Path", component: Profile },
  //     { path: "/assess/actions", name: "Actions Aligned Path", component: Profile }
  //   ]
  // }, 
  // {
  //   collapse: true,
  //   path: "/grow",
  //   name: "Grow",
  //   icon: DashboardIcon,
  //   state: "openGrow",
  //   views: [
  //     { path: "/grow/articles", name: "Articles Library", component: Profile },   
  //     { path: "/grow/tudies", name: "Research Studies Library", component: Profile },   
  //     { path: "/grow/books", name: "Books Library", component: Profile },   
  //     { path: "/grow/share", name: "Share a Resource", component: Profile },   
  //     { path: "/grow/consultants", name: "Directory of Consultants", component: Profile },   
  //     { path: "/grow/professionals", name: "Directory of Consultants", component: Profile },   
  //     { path: "/grow/courses", name: "Upcoming Courses", component: Profile },
  //     { path: "/grow/archive", name: "Course Archive", component: Profile },
  //     { path: "/grow/suggest", name: "Suggest a Course or Webinar", component: Profile }
  //   ]
  // }, 
  // {
  //   collapse: true,
  //   path: "/connect",
  //   name: "Connect",
  //   icon: DashboardIcon,
  //   state: "openConnect",
  //   views: [
  //     { path: "/connect/communities", name: "Communities of Interest", component: Profile },   
  //     { path: "/connect/blog", name: "Blog", component: Profile },
  //     { path: "/connect/newsletter", name: "Newsletter", component: Profile },     
  //     { path: "/connect/radio", name: "Radio", component: Profile },     
  //     { path: "/connect/group-calls", name: "Group Calls", component: Profile },     
  //     { path: "/connect/group-calls", name: "Affliates", component: Profile },
  //     { path: "/connect/member", name: "Become a Member", component: Profile }, 
  //     { path: "/connect/partner", name: "Become a Partner", component: Profile }, 
  //     { path: "/connect/champion", name: "Become a Champion", component: Profile },
  //     { path: "/connect/sponsor", name: "Become a Sponsor or Donor", component: Profile },
  //     { path: "/connect/advocate", name: "Become an Advocate", component: Profile },   
  //     { path: "/connect/marketplace", name: "Talent Marketplace", component: Profile }     
    
  //   ]
  // }, 
  // {
  //   collapse: true,
  //   path: "/about",
  //   name: "About",
  //   icon: DashboardIcon,
  //   state: "openAbout",
  //   views: [
  //     { path: "/about/who-we-are", name: "Who we Are", component: Profile },   
  //     { path: "/about/champions", name: "Our Champions", component: Profile },  
  //     { path: "/about/bbard", name: "Our Board Members", component: Profile },     
  //     { path: "/about/sponsors", name: "Our Sponsors", component: Profile },     
  //     { path: "/about/memmbers", name: "Member Directory", component: Users }     
  //   ]
  // }, 
  // { path: "/contact", name: "Contact", component: Profile },    
  
  // { path: "/dashboard/apply", name: "Job Application", component: JobApplication },
  // {
  //   collapse: true,
  //   path: "/admin",
  //   name: "Admin",
  //   icon: DashboardIcon,
  //   views: [
  //     { path: "/dashboard/brokering/orders", name: "Brokering: Orders", component: Orders },
  //     { path: "/dashboard/brokering/brokers", name: "Brokering: Brokers", component: Brokers }
  //   ]
  // },
  // {
  //   collapse: true,
  //   path: "/field",
  //   name: "Field",
  //   icon: DashboardIcon,
  //   views: [
  //     { path: "/dashboard/brokering/orders", name: "Brokering: Orders", component: Orders },
  //     { path: "/dashboard/brokering/brokers", name: "Brokering: Brokers", component: Brokers }
  //   ]
  // },
  // {
  //   collapse: true,
  //   path: "/communications",
  //   name: "Communications",
  //   icon: DashboardIcon,
  //   views: [
  //     { path: "/dashboard/brokering/orders", name: "Brokering: Orders", component: Orders },
  //     { path: "/dashboard/brokering/brokers", name: "Brokering: Brokers", component: Brokers }
  //   ]
  // },
  // {
  //   collapse: true,
  //   path: "/volunteers",
  //   name: "Volunteers",
  //   icon: DashboardIcon,
  //   views: [
  //     { path: "/dashboard/brokering/orders", name: "Brokering: Orders", component: Orders },
  //     { path: "/dashboard/brokering/brokers", name: "Brokering: Brokers", component: Brokers }
  //   ]
  // },
  // {
  //   collapse: true,
  //   path: "/political",
  //   name: "Political",
  //   icon: DashboardIcon,
  //   views: [
  //     { path: "/dashboard/brokering/orders", name: "Brokering: Orders", component: Orders },
  //     { path: "/dashboard/brokering/brokers", name: "Brokering: Brokers", component: Brokers }
  //   ]
  // },
  // {
  //   collapse: true,
  //   path: "/fundraising",
  //   name: "Fundraising",
  //   icon: DashboardIcon,
  //   views: [
  //     { path: "/dashboard/brokering/orders", name: "Brokering: Orders", component: Orders },
  //     { path: "/dashboard/brokering/brokers", name: "Brokering: Brokers", component: Brokers }
  //   ]
  // },
  // {
  //   collapse: true,
  //   path: "/treasurer",
  //   name: "Treasurer",
  //   icon: DashboardIcon,
  //   views: [
  //     { path: "/dashboard/brokering/orders", name: "Brokering: Orders", component: Orders },
  //     { path: "/dashboard/brokering/brokers", name: "Brokering: Brokers", component: Brokers }
  //   ]
  // },
  // {
  //   collapse: true,
  //   path: "/legal",
  //   name: "Legal",
  //   icon: DashboardIcon,
  //   views: [
  //     { path: "/dashboard/brokering/orders", name: "Brokering: Orders", component: Orders },
  //     { path: "/dashboard/brokering/brokers", name: "Brokering: Brokers", component: Brokers }
  //   ]
  // },
  // {
  //   collapse: true,
  //   path: "/technology",
  //   name: "Technology",
  //   icon: DashboardIcon,
  //   views: [
  //     { path: "/dashboard/brokering/orders", name: "Brokering: Orders", component: Orders },
  //     { path: "/dashboard/brokering/brokers", name: "Brokering: Brokers", component: Brokers }
  //   ]
  // },
  // {
  //   collapse: true,
  //   path: "/scheduling",
  //   name: "Scheduling",
  //   icon: DashboardIcon,
  //   views: [
  //     { path: "/dashboard/brokering/orders", name: "Brokering: Orders", component: Orders },
  //     { path: "/dashboard/brokering/brokers", name: "Brokering: Brokers", component: Brokers }
  //   ]
  // }

];





// WEBPACK FOOTER //
// ./src/routes/dashboard.jsx